export const landing: LandingSetup = {
    background: '/assets/landing/background.png',
    title: 'Startup Poker',
    text: `<p><b>Innovation is like poker.</b></p>
            <p>You face a high degree of uncertainty and competitors with unknown capabilities. To win, you need to make great decisions with limited information.</p>
            <p>This interactive simulation will explain:</p>`,
    registrationTitle: 'Access the simulation:',
    registrationText: 'You will receive access to all Kromatic resources, news and updates.',
    startButton: 'Play now!',
    practiceButton: 'skip to practice',
    illustration: '/assets/landing/illustration.png',
    illustrationAlt: '',
    point1: {
        icon: '/assets/landing/psychology_alt.svg',
        iconAlt: 'Head with question mark for go/no-go decisions',
        label: 'How to make wise go / no-go decisions',
    },
    point2: {
        icon: '/assets/landing/currency_exchange.svg',
        iconAlt: 'Circular arrows for value of information',
        label: 'The value of information',
    },
    point3: {
        icon: '/assets/landing/dangerous.svg',
        iconAlt: 'Crossed box for ending projects',
        label: 'When to kill innovation projects',
    },
    point4: {
        icon: '/assets/landing/stacked_line_chart.svg',
        iconAlt: 'Upward graph for competition impact',
        label: 'How competition impacts success',
    },
};
